import React, { useState, useEffect } from "react";
import { axiosSalary } from "../api/axiosInstance";
import { useAuth } from "../auth/AuthContext";

const LockAttendance = ({ open, onClose, rowData, onSuccess }) => {

  const { user } = useAuth();

  const [reason, setReason] = useState("");

  /* ================= RESET ================= */
  useEffect(() => {
    if (rowData) {
      setReason("");
    }
  }, [rowData]);

  /* ================= SUBMIT ================= */
  const handleLock = async () => {

    try {

      const payload = {
        groupId: user?.groupId,
        restId: rowData.restId,
        empId: rowData.empId,

        attendanceDate: new Date(
          rowData.attendanceDate.split("/").reverse().join("-")
        ).toISOString(),

        userId: user?.userId,
        reason: reason
      };

      await axiosSalary.post(
        "/DailyAttendance/LockAttendance",
        payload
      );

      alert("Attendance locked successfully");

      onClose();
      onSuccess && onSuccess();

    } catch (err) {
      console.error("Lock error:", err);
      alert("Failed to lock attendance");
    }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">

      <div className="bg-white rounded-lg p-4 w-[320px]">

        <h3 className="font-semibold mb-3">
          Lock Attendance - {rowData?.empName}
        </h3>

        <p className="text-xs text-gray-500 mb-2">
          This action will prevent further edits.
        </p>

        <textarea
          placeholder="Reason (optional)"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          className="w-full border p-2 rounded text-sm"
        />

        <div className="flex justify-end gap-2 mt-3">

          <button
            onClick={onClose}
            className="px-3 py-1 border rounded"
          >
            Cancel
          </button>

          <button
            onClick={handleLock}
            className="px-3 py-1 bg-red-600 text-white rounded"
          >
            Lock
          </button>

        </div>

      </div>

    </div>
  );
};

export default LockAttendance;